import { ArrowRight } from "lucide-react";
import FadeUp from "@/components/landing/FadeUp";
import { FINAL_CTA } from "./content";
import { scrollToId } from "./utils";
import { PrimaryButton } from "./Primitives";

export const HireFinalCTA = () => (
    <section id="final-cta" data-testid="hire-final-cta" className="section-pad bg-white">
        <div className="container-page">
            <div className="relative overflow-hidden rounded-3xl bg-brand-blue text-white px-7 py-14 md:px-16 md:py-20 text-center">
                <div aria-hidden className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-white/10" />
                <div aria-hidden className="absolute -bottom-32 -left-20 h-80 w-80 rounded-full bg-white/[0.06]" />
                <FadeUp>
                    <h2 data-testid="final-cta-heading" className="relative font-bold text-[32px] leading-[1.15] sm:text-4xl md:text-[48px] text-balance">
                        {FINAL_CTA.heading}
                    </h2>
                </FadeUp>
                <FadeUp delay={0.08}>
                    <p className="relative mt-5 text-base md:text-lg text-white/80 max-w-2xl mx-auto leading-relaxed">
                        {FINAL_CTA.body}
                    </p>
                </FadeUp>
                <FadeUp delay={0.14}>
                    <PrimaryButton
                        data-testid="final-cta-button"
                        onClick={() => scrollToId("hire-form")}
                        className="relative mt-9 bg-white text-brand-blue hover:bg-white/90 hover:text-brand-blue-dark shadow-none h-[52px] px-8"
                    >
                        {FINAL_CTA.cta} <ArrowRight className="h-4 w-4" />
                    </PrimaryButton>
                </FadeUp>
            </div>
        </div>
    </section>
);

export default HireFinalCTA;
